import { makeStyles } from '@material-ui/core/styles';
import transitions from '@material-ui/core/styles/transitions';
const useStyles = makeStyles((theme: any) => {
  return {
    container: { flexDirection: 'row', display: 'flex' },
    dot: {
      width: '17px',
      height: '17px',
      borderRadius: '15px',
      backgroundColor: theme.custom.colors.disabledText,
    },
    dotPurple: {
      backgroundColor: theme.custom.colors.purpleOpacity50
    },
    dot_zoom_out_grey: {
      animationName: '$zoom_out_color',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
    },
    dot_zoom_out_purple: {
      animationName: '$zoom_out_color_purple',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
    },
    dot_zoom_in: {
      animationName: '$zoom_in_color',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
    },
    line: {
      width: '36px',
      height: '2px',
      backgroundColor: theme.custom.colors.grey1,
      margin: '0px 7px',
    },
    viewDot: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
    },
    '@keyframes zoom_out_color': {
      from: { backgroundColor: theme.custom.colors.purple },
      to: {
        backgroundColor: theme.custom.colors.disabledText,
        transform: 'scale(1)',
      },
    },

    '@keyframes zoom_out_color_purple': {
      from: { backgroundColor: theme.custom.colors.purple },
      to: {
        backgroundColor: theme.custom.colors.purpleOpacity50,
        transform: 'scale(1)',
      },
    },

    '@keyframes zoom_in_color': {
      from: { backgroundColor: theme.custom.colors.disabledText },
      to: {
        backgroundColor: theme.custom.colors.purple,
        transform: 'scale(1.4)',
      },
    },
  };
});

export default useStyles;
